import { ReactSVG } from "react-svg";

export const CollectionImagePreview = ({ previewURL, index }) => {
  return previewURL?.split(".")?.pop() == "svg" ? (
    <ReactSVG src={previewURL} className="preview-svg" />
  ) : (
    <img key={index} src={previewURL} alt="" className="collection-img" />
  );
};
